export default __webpack_public_path__ + "static/media/urn-newsml-dpa-com-20090101-190401-99-630624-large-4-3.62b7a49d.jpg";